import { TagsAndWorkOrdersState } from "../../../redux";
import { SeverityType, WonosStatusResponse } from "../../../types";

export const mockTags = [
  {
    alarm_status: SeverityType.Critical,
    cd_tag: "TAG-1",
    equipment_name: "Equipment name 1",
    reference_drawing: "TAG-REF-DRAWING-1",
  },
  {
    alarm_status: SeverityType.Normal,
    cd_tag: "TAG-2",
    equipment_name: "Equipment name 2",
    reference_drawing: "TAG-REF-DRAWING-2",
  },
];

const workOrdersProps: WonosStatusResponse = {
  due_date: "",
  job_code: "",
  job_description: "",
  job_status_code: 0,
  job_status_color: "",
  manual_changes: false,
  revision_request_qty: 0,
  work_order_number: "",
  work_order_type: "",
  priority: null,
  system: "",
  linked_mahs_list: [],
  linked_sces_list: [],
  linked_tags_list: [],
  maint_class: null,
  effect: null,
  tag_type: "SCE-ONLY",
};

export const workOrders: WonosStatusResponse[] = [workOrdersProps];

export const ctos = {
  ongoing: ["CTO-1", "CTO-2"],
  notStarted: ["CTO-5"],
};

export const currentTagCorrectives = [
  {
    closed: true,
    description: "Description :P",
    wono: "WO-3",
  },
];

export const mockTagsAndWorkOrdersState: TagsAndWorkOrdersState = {
  alarmStatus: SeverityType.NoInfo,
  ctos: {
    ongoing: [],
    notStarted: [],
  },
  selectedTag: "TG-000",
  workOrders: [],
  isLoadingWorkOrders: true,
};

export const initialState = {
  tagsAndWorkOrders: mockTagsAndWorkOrdersState,
};

export const initialStateWithTags = {
  tagsAndWorkOrders: {
    ...mockTagsAndWorkOrdersState,
    selectedSce: "SCE-F",
    sceName: "SCE Name",
    mahName: "MAH Name",
    barrierId: "Barrier ID",
    originName: "Origin Name",
    isLoadingTags: false,
    tags: mockTags,
  },
};

export const initialStateWithWorkOrders: {
  tagsAndWorkOrders: TagsAndWorkOrdersState;
} = {
  tagsAndWorkOrders: {
    ...mockTagsAndWorkOrdersState,
    selectedTag: "TAG-1",
    isLoadingWorkOrders: false,
    workOrders,
  },
};
